// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import 'es6-promise/auto'
import axios from 'axios'

// Internal Dependencies:
import Stripe from 'components/Stripe/Stripe'

const host = window.location.host

class PageEvents extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			showStripeModal: false,
			stripeModalAmount: 0,
			stripeModalRecur: false
		}
	}

	componentDidMount() {
		this.doUpdate()
	}

	componentWillUnmount() {
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
		window.removeEventListener( 'click', this.handleAccordionTitleClick )
		window.removeEventListener( 'click', this.handleDonateButtonTypeClick )
		window.removeEventListener( 'click', this.handleDonateButtonClick )
		window.removeEventListener( 'click', this.handleDonateButtonCustomClick )
	}

	componentDidUpdate( prevProps, prevState ) {
		this.doUpdate()
	}

	doUpdate() {
		// Links:
		const elements = document.querySelectorAll( '.content-body-wrap a, .content-custom-wrap a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		})

		// Forms:
		const forms = document.querySelectorAll( '.content-body-wrap form, .content-custom-wrap form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )
		})

		// Recaptchas:
		const recaptchas = document.querySelectorAll( '.page-section .frm-g-recaptcha, .content-custom-wrap .frm-g-recaptcha' )

		Array.from( recaptchas ).forEach( ( recaptcha ) => {
			if ( 'undefined' != typeof grecaptcha ) {
				let recaptchaID = grecaptcha.render( recaptcha, {
					'sitekey': recaptcha.getAttribute( 'data-sitekey' )
				} )
				recaptcha.setAttribute( 'data-rid', recaptchaID )
				recaptcha.classList.remove( 'frm-g-recaptcha' )
			}
		})

		// Accordions:
		const accordionTitles = document.querySelectorAll( '.accordion-title' )

		Array.from( accordionTitles ).forEach( ( accordionTitle ) => {
			accordionTitle.addEventListener( 'click', this.handleAccordionTitleClick )
		})

		// Donate buttons:
		const donateButtonTypess = document.querySelectorAll( '.donate-button-type' )

		Array.from( donateButtonTypess ).forEach( ( donateButton ) => {
			donateButton.addEventListener( 'click', this.handleDonateButtonTypeClick )
		})

		const donateButtons = document.querySelectorAll( '.donate-button-preset' )

		Array.from( donateButtons ).forEach( ( donateButton ) => {
			donateButton.addEventListener( 'click', this.handleDonateButtonClick )
		})

		const donateButtonsCustom = document.querySelectorAll( '.donate-button-custom' )

		Array.from( donateButtonsCustom ).forEach( ( donateButtonCustom ) => {
			donateButtonCustom.addEventListener( 'click', this.handleDonateButtonCustomClick )
		})
	}

	handleLinkClick = ( e ) => {
		const { history } = this.props
		let href = e.currentTarget.getAttribute( 'href' )
		href = href.replace( /^(\.+)/g, '' )

		if ( href.indexOf( host ) > -1 && href.indexOf( '//' ) > -1 ) {
			window.location( href ) // Same network, different site, open normally.
		} else if ( href.indexOf( '//' ) > -1 ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash
		} else {
			history.push( href ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmit = ( e ) => {
		const form = e.currentTarget
		const buttons = form.querySelectorAll( 'button' )
		const formData = new FormData( form )
		formData.append( 'action', 'atsim_formidable_submit_form' )

		e.preventDefault()

		// disable the button
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// submit
		axios.post( siteData.ajax_url, formData )
		.then( response => {
			// success

			form.classList.remove( 'has-error' )
			form.setAttribute( 'data-message', '' )

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-successful' )

				// set the success message
				form.setAttribute( 'data-message', response.data )

				setTimeout( () => {
					form.classList.remove( 'is-successful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}

					// clear form
					form.reset()
				}, 1000 )
			}, 1000 )
		})
		.catch( error => {
			// error

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-unsuccessful' )

				// set the error text
				form.classList.add( 'has-error' )
				error.response && form.setAttribute( 'data-message', error.response.data )

				setTimeout( () => {
					form.classList.remove( 'is-unsuccessful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}
				}, 3000 )
			}, 1000 )
		})
	}

	handleAccordionTitleClick = ( e ) => {
		e.preventDefault()

		let section = e.currentTarget.parentNode

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
		} else {
			section.classList.add( 'is-closing' )
			section.classList.remove( 'is-active' )
			section.classList.remove( 'is-target' )

			setTimeout( () => {
				section.classList.remove( 'is-closing' )
				section.classList.add( 'is-not-active' )
			}, 750 )
		}
	}

	handleDonateButtonTypeClick = ( e ) => {
		e.preventDefault()

		let button = e.currentTarget
		let type = button.getAttribute( 'data-type' )
		let parent = button.parentNode.parentNode.parentNode.parentNode
		let activeButton = parent.querySelector( '.donate-button-type.is-active' )

		if ( ! type || ! parent ) {
			return
		}

		button.classList.add( 'is-active' )

		if ( activeButton ) {
			activeButton.classList.remove( 'is-active' )
		}

		if ( 'recur' == type ) {
			parent.classList.add( 'is-recurring' )
			parent.classList.remove( 'is-single' )
		} else {
			parent.classList.add( 'is-single' )
			parent.classList.remove( 'is-recurring' )
		}

		this.setState({
			stripeModalRecur: 'recur' == type
		})
	}

	handleDonateButtonClick = ( e ) => {
		e.preventDefault()

		let amount = e.currentTarget.getAttribute( 'data-amount' )

		this.showDonateForm( amount, false )
	}

	handleDonateButtonCustomClick = ( e ) => {
		e.preventDefault()

		let amount = e.currentTarget.parentNode.querySelector( 'input' ).value
		let recur = e.currentTarget.parentNode.getAttribute( 'data-recur' ) ? true : false

		if ( ! amount ) {
			alert( 'Please enter an amount' )
			return
		}

		this.showDonateForm( amount, recur )
	}

	showDonateForm = ( amount, recur ) => {
		this.setState({
			showStripeModal: true,
			stripeModalAmount: amount
		})
	}

	handleDonateAccept = () => {
		this.setState({
			showStripeModal: false,
			stripeModalAmount: 0
		})
	}

	handleDonateCancel = () => {
		this.setState({
			showStripeModal: false,
			stripeModalAmount: 0
		})
	}

	render() {
		const { showStripeModal, stripeModalAmount, stripeModalRecur } = this.state
		let heading = 'Donate $' + stripeModalAmount + ' to ' + siteData.site_name

		if ( stripeModalRecur ) {
			heading = 'Donate $' + stripeModalAmount + ' (monthly) to ' + siteData.site_name
		}

		return (
			<div>
				{ showStripeModal &&
					<Stripe
						amount={ stripeModalAmount }
						recur={ stripeModalRecur }
						heading={ heading }
						acceptText="Confirm"
						accept={ this.handleDonateAccept }
						cancel={ this.handleDonateCancel }
					>
					</Stripe>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps )( PageEvents )
)



// WEBPACK FOOTER //
// ./views/page/PageEvents.jsx